<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 16:48:38
 * @LastEditTime: 2024-06-05 10:24:53
 * @LastEditors: 张天昊
 * @Description: 导游面板
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/GuidePanel.vue
-->
<script>
import { defineComponent, computed } from 'vue';
import { omit } from 'lodash';
import GuideCard from './GuideCard.vue';
import DataEmpty from './DataEmpty.vue';
import { useAuxiliaryInfoCardScroll } from '../composables/useAuxiliaryInfoCardScroll';
import { usePanelMinHeight } from '../composables/usePanelMinHeight';
import { AuxiliaryInfoTypes } from '../constants';
import store from '@/store';

export default defineComponent({
  name: 'GuidePanel',
  components: {
    GuideCard,
    DataEmpty
  },
  setup(_, { expose }) {
    const detailInfo = computed(
      () => store.state.itineraryUniversal.detailInfo.value
    );
    const datas = computed(() =>
      detailInfo.value ? detailInfo.value.itineraryGuideMessages : []
    );
    const { cards, anchorTo } = useAuxiliaryInfoCardScroll(
      AuxiliaryInfoTypes.导游
    );
    const { panelMinHeight } = usePanelMinHeight();
    expose({
      anchorTo
    });
    return {
      cards,
      datas,
      omit,
      panelMinHeight
    };
  }
});
</script>

<template>
  <div class="px-12 pt-16" :style="{ minHeight: panelMinHeight }">
    <!-- 块 -->
    <template v-if="datas.length">
      <GuideCard
        v-for="data in datas"
        :key="data.guideId"
        :data="data"
        ref="cards"
        class="[&:not(:first-child)]:mt-16"
      />
    </template>
    <DataEmpty v-else />
  </div>
</template>
